module.exports = __webpack_public_path__ + "img/slider_network-traffic.dcb7fe9e.png";